export default __webpack_public_path__ + "static/media/Shampoo_Grand_stretch.1fccb4b9.png";